define.alias("shared/components/shared/wizard/finish-button", "calendar/components/shared/wizard/finish-button");